import React from 'react';
import {
  Form, Input, InputNumber, DatePicker, Radio, Icon,
} from '@roo/roo';
import { get } from 'lodash';
import { useUpdateEffect } from 'ahooks';
import { getRuleLen } from '@utils/rules';
import { useUserData } from '@components/UserData';
import { getSafeDate } from '@utils/utils';
import { sendFileLx } from '@utils/lxUtils';
import download from '@assets/images/download.png';
import { getTemplateFileUrl } from '@assets/apis/innovate';
import { useSimpleContext } from '../../_context';
import { getPopContainer } from '../../_utils';

const { Field } = Form;
const RadioGroup = Radio.Group;

export const Info = function () {
  const { state } = useSimpleContext((t) => [t.innovate.projectDict, t.disabled]);
  const { inoTopicList: reportData } = useUserData();
  const disabled = state.disabled;
  useUpdateEffect(
    () => {
      setFieldValue('reportDirection', get(reportData, '0.id'));
    },
    [reportData],
  );

  return (
    <div className="form-patch">
      <Field
        required
        rule={getRuleLen(20, true)}
        name="projectName"
        label="项目名称"
        as={<Input maxLength={20} placeholder="请输入项目名称" />}
      />
      <Field
        required
        rule={getRuleLen(50, true)}
        name="projectLocation"
        label="项目所在地"
        as={<Input maxLength={50} placeholder="请输入项目所在地或计划落地" />}
      />
      {/* <Field
        required={true}
        rule={{ ...requiredRule, type: 'number' }}
        name={`investmentAmount`}
        label='项目总投资'
        as={<InputNumber style={{width:'100%'}} className={'prefix-w'} max={9999999} min={0} placeholder={'请输入数字（可输入小数点），若无则填0'}></InputNumber>}
      /> */}
      <Field
        required={false}
        name="locationArea"
        placeholder="请输入数字（可输入小数点），若无则填0"
        label="占地面积"
        as={<InputNumber style={{ width: '100%' }} className="prefix-a" max={9999999} min={0} placeholder="请输入数字（可输入小数点），若无则填0" />}
      />
      <Field label="开工日期" name="startDate">
        {({ value, handleChange, disabled }) => (
          <DatePicker
            flip
            clearable
            disabled={disabled}
            value={getSafeDate(value)}
            format="YYYY-MM-DD"
            valueOfType="string"
            popupContainer={getPopContainer}
            onChange={(value) => {
              handleChange(value);
            }}
          />
        )}
      </Field>
      <Field label="竣工日期" name="endDate">
        {({ value, handleChange, disabled }) => (
          <DatePicker
            flip
            clearable
            disabled={disabled}
            value={getSafeDate(value)}
            format="YYYY-MM-DD"
            valueOfType="string"
            popupContainer={getPopContainer}
            onChange={(value) => {
              handleChange(value);
            }}
          />
        )}
      </Field>
      <Field required name="reportDirection" label="项目申报方向" layout="vertical">
        {({ value, handleChange }) => {
          const opts = reportData || [];
          if (!value && value !== 0 && opts.length) {
            handleChange(get(opts, '0.id'));
          }
          return (
            <div>
              <div className="t-info">
                <Icon name="info-circle-o" />
                示范项目需聚焦外卖包装以及废弃物处理场景
              </div>
              <RadioGroup value={value} onChange={handleChange} disabled={disabled}>
                {opts.map((item) => <Radio value={item.id}>{item.name}</Radio>)}
              </RadioGroup>
            </div>
          );
        }}
      </Field>
      <br />
      {
        state?.values?.reportDirection ? (
          <div style={{ width: '100%', margin: '16px 0' }}>
            <span
              style={{ cursor: 'pointer', color: '#222' }}
              onClick={() => {
                getTemplateFileUrl({ fileType: 'organizationApplyFile', param: state.values.reportDirection })
                  .then((url) => {
                    window.open(url);
                    sendFileLx(url);
                  });
              }}
            >
              <img src={download} alt="" />
              下载模板
            </span>
          </div>
        ) : null
      }

    </div>
  );
};
